// extracted by mini-css-extract-plugin
export var active = "_2s-2";
export var highlight = "_2s-1";
export var highlightLayer = "_2s-0";
export var issuePopover = "_2s-3";
export var statusIcon = "_2s-4";